<template>
    <div>
        <div v-if="loading">
            <loading/>
        </div>

        <div v-if="hasError">
            <b-alert variant="danger" show>
                {{ errorMessage }}
            </b-alert>

            <b-button v-if="canReactivate" variant="primary" @click="reactivateClient">
                <i class="far fa-trash-undo-alt fa-fw mr-2"/> Réactiver le client supprimé
            </b-button>
            <b-button v-else variant="primary" @click="reset">
                <i class="far fa-plus fa-fw mr-2"/>Créer un autre client
            </b-button>
        </div>

        <div v-if="!loading && !hasError">
            <h4 class="mb-3">Etape 1 : Type de personne</h4>
            <b-form-radio-group @change="step2">
                <b-form-radio v-model="person" name="person" value="PM">
                    Personne Morale
                </b-form-radio>
                <b-form-radio v-model="person" name="person" value="PP">
                    Personne Physique
                </b-form-radio>
            </b-form-radio-group>

            <div v-if="step > 1">
                <hr/>
                <h4 class="mb-3">Etape 2 : SIREN</h4>
                <div class="row">
                    <div class="col-6">
                        <b-input
                            v-model="form.siren"
                            size="sm"
                            :disabled="hasNoSiren"
                            :formatter="sirenFormatter"
                            @update="step3"
                        />
                    </div>
                    <div class="col-6 pt-1">
                        <b-form-checkbox v-model="hasNoSiren" @change="step3">
                            Pas de SIREN
                        </b-form-checkbox>
                    </div>
                </div>
            </div>

            <div v-if="step > 2">
                <hr/>
                <h4 class="mb-3">Etape 3 : Nom</h4>
                <div v-if="person === 'PM'" class="row mt-3">
                    <div class="col-6">
                        <label>Nom de la société</label>
                        <b-input v-model="form.name" size="sm" :state="form.name!==''"/>
                    </div>
                    <div class="col-6">
                        <b-form-group
                            label="Forme Juridique"
                            :state="form.legal_form_id!==null">
                            <b-select
                                v-model="form.legal_form_id"
                                size="sm"
                                :options="legalFormsOptions"
                                :state="form.legal_form_id!==null"
                            >
                                <template #first>
                                    <b-form-select-option
                                        :value="null"
                                        disabled
                                        selected
                                    >
                                        -- Sélectionner une forme juridique --
                                    </b-form-select-option>
                                </template>
                            </b-select>
                        </b-form-group>
                    </div>
                </div>
                <div v-else class="row mt-3">
                    <div class="col-6">
                        <label>Prénom</label>
                        <b-input v-model="form.first_name" size="sm"/>
                    </div>
                    <div class="col-6">
                        <label>Nom</label>
                        <b-input v-model="form.last_name" size="sm"/>
                    </div>
                </div>
            </div>
            <b-button
                size="sm"
                variant="success"
                class="mt-3"
                :disabled="disableSubmit"
                @click="storeClient"
            >
                <i class="far fa-save"></i> Enregistrer
            </b-button>
        </div>
    </div>
</template>

<script>
import Formatter from '../../../common/mixins/Formatter'
import loading from '../../../common/components/loading'

export default {
    name: 'NewClient',

    components: {
        loading,
    },

    mixins: [Formatter],

    props: {
        legalFormsOptions: null,
    },

    data() {
        return {
            step: 1,
            person: null,
            hasNoSiren: false,
            loading: false,
            hasError: false,
            errorMessage: '',
            canReactivate: false,
            form: {
                person: '',
                legal_form_id: null,
                name: '',
                first_name: '',
                last_name: '',
                siren: '',
            },
        }
    },

    computed: {
        baseUrl() {
            return document.head.querySelector('meta[name="base-url"]').content
        },

        sirenIsValid() {
            return this.form.siren.length === 11
        },

        disableSubmit() {
            if (this.sirenIsValid) {
                return false
            }
            if (this.person === 'PP') {
                return this.form.first_name === '' || this.form.last_name === ''
            }
            return this.form.name === '' || this.form.legal_form_id === null
        },
    },

    methods: {
        reset() {
            this.step = 1
            this.person = null
            this.hasNoSiren = false
            this.loading = false
            this.hasError = false
        },

        step2() {
            this.form.siren = ''
            this.hasNoSiren = false
            this.step = 2
        },

        step3() {
            if (this.hasNoSiren) {
                this.form.siren = ''
                this.step = 3
            } else {
                this.form.legal_form_id = null
                this.form.name = ''
                this.form.first_name = ''
                this.form.last_name = ''
                this.step = 2
            }
        },

        async storeClient() {
            this.loading = true
            this.form.person = this.person
            try {
                const response = await axios.post('/clients', this.form)
                window.location.href = `${this.baseUrl}/pilotage-activite/clients/${response.data.data.uuid}/pappers`
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 422) {
                        this.errorMessage = error.response.data.meta.message
                        this.canReactivate = error.response.data.meta.can_reactivate
                        this.hasError = true
                        this.loading = false
                    }
                }
            }
        },

        async reactivateClient() {
            try {
                const response = await axios.put('/clients/reactivate', this.form)
                window.location.href = `${this.baseUrl}/pilotage-activite/clients/${response.data.data.uuid}/interne`
            } catch (error) {
                //
            }
        },
    },
}
</script>

<style scoped></style>
